import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Paper} from '@mui/material';
import PublicItemView from "./PublicItemView";
import {API_ROOT, BASE_URL} from "../../../../../baseUrls";
import {useParams} from "react-router";
import InfoText from "../../../../util/common/InfoText";
import {Link} from "@mui/material";

const styles = {
  root:{
    maxWidth:'800px',
    width:'calc(100% - 2rem)',
    margin:'1rem auto',
    overflow:'auto',
    border: '1px solid rgba(0,0,0,0.17)',
  },
  info:{
    maxWidth:'800px',
    width:'calc(100% - 2rem)',
    margin:'1rem auto',
    // fontWeight: 300,
  },
  link:{
    textTransform: 'uppercase',
    fontSize: '0.85em',
    fontWeight: 500,
  },
  linkSecondary:{
    fontWeight: 300,
  }
};

function getShareDetails(authToken, shareHash, callback = (data) => {}) {
  fetch(`${ API_ROOT }/share/item/${ shareHash }`, {
    method: 'GET',
    credentials: 'include',
    headers: {'X-CSRF-Token': authToken},
  })
  .then(response => response.json())
  .then(data => callback(data))
  .catch(err => console.error(err));
}

function PublicItemPage(props) {
  const { authToken, classes } = props;
  let {shareHash} = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    if(!shareHash){
      setItem(null);
    }
    getShareDetails(authToken, shareHash, setItem);
    return () => setItem(null);
  },
  // eslint-disable-next-line ignore missing authToken in dep list
  [shareHash]);

  return !item ? null : (
    <div>
      <Paper className={classes.root}>
        <InfoText className={classes.info}>
          <Link href={BASE_URL} underline="always" color="primary" className={classes.link}>LifeNaut</Link> is a web based research project that allows anyone
          to <Link className={classes.linkSecondary} href={`${BASE_URL}/learn-more/`}>create a free back-up of their mind</Link> and <Link className={classes.linkSecondary} href={`${BASE_URL}/biofile`}>genetic code</Link>.
        </InfoText>
      </Paper>
      <Paper className={classes.root}>
        <PublicItemView item={item} shareHash={shareHash} setItem={setItem} />
      </Paper>
    </div>
  );
}

export default withStyles(styles)(PublicItemPage);
